<template>
    <div>
        <BreadCrumb :data="breadCrumb" />
        <b-card header-tag="header" footer-tag="footer">  
            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                                  
            <div class="auths" v-else>
                    <b-form-group class="inputGrp" label-for="country">
                        <treeselect
                            :multiple="true"
                            :options="unauthorizedMenus"
                            :placeholder="$t('user.menus.allMenus')"
                            :noOptionsText="$t('user.menus.noOptionsText')"
                            v-model="selectedMenus"
                            :show-count="false"
                            :default-expand-level="1"
                            :normalizer="normalizer"
                            :always-open="true"
                            maxHeight="350"
                            :flat="true"
                        >
                             <label slot="option-label" slot-scope="{ node, shouldShowCount, count }">
                               <b-icon :icon="node.raw.icon"></b-icon> {{ node.label }}
                                <span v-if="shouldShowCount">({{ count }})</span>
                            </label>
                        </treeselect>
                       
                    
                    </b-form-group>
                    
                    <div class="buttons">
                        <b-button :title="$t('user.menus.transferAll')" size="sm" variant="outline-primary" @click="sendAllMenus"> <b-icon icon="chevron-double-right"> </b-icon>  </b-button> 
                        <b-button :title="$t('user.menus.transferSelecteds')" size="sm" variant="outline-primary" @click="sendSelectMenus" > <b-icon icon="chevron-right" ></b-icon>  </b-button>
                        <b-button :title="$t('user.menus.removeSelecteds')" size="sm" variant="outline-primary" @click="sendSelectMenus('remove')"> <b-icon icon="chevron-left"></b-icon> </b-button> 
                        <b-button :title="$t('user.menus.removeAll')" size="sm" variant="outline-primary" @click="sendAllMenus('remove', authMenus)"> <b-icon icon="chevron-double-left"> </b-icon>  </b-button> 
                    </div>

                    <b-form-group class="inputGrp" >
                         <treeselect
                            :multiple="true"
                            :options="authMenus"
                            :placeholder="$t('user.menus.authMenus')"
                            :noOptionsText="$t('user.menus.noOptionsText2')"
                            v-model="selectedAuthMenus"
                            :show-count="false"
                            :default-expand-level="1"
                            :normalizer="normalizer"
                            :always-open="true"
                            maxHeight="350"
                            :flat="true"
                        >
                             <label slot="option-label" slot-scope="{ node, shouldShowCount, count }">
                               <b-icon :icon="node.raw.icon"></b-icon> {{ node.label }}
                                <span v-if="shouldShowCount">({{ count }})</span>
                            </label>
                        </treeselect>                    
                    </b-form-group>
            </div>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />
    
    </div>
</template>
<script>
    import i18n from '@/plugins/i18n';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import BreadCrumb from '@/components/BreadCrumb'
    let breadCrumb = [
        { label: i18n.t('pages.user.auths'), url: "/User/Auth" },
    ]

    export default {
        name: "Users",
        created: async function(){
            this.breadCrumb.length > 2 && this.breadCrumb.pop()
            this.breadCrumb.push({ label: this.$route.params.id, url: "/User/Auth" })
            await this.$store.dispatch('listUserMenu')
            await this.$store.dispatch('listAuthMenu',this.$route.params.id)
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            normalizer(node) {
                return { id: node.id, label: node.menu_detail[0].title,  icon: node.icon, children: node.children}
            },
            sendAllMenus: async function(action, menus = this.menus){
                this.selectedMenus = []
                menus.map(menu => {
                    this.selectedMenus.push(menu.id)
                    if(menu.children && menu.children.length>0){
                        menu.children.map(child => {
                            this.selectedMenus.push(child.id)
                        })
                    }
                })
                 let params = {
                    auth: this.$route.params.id,
                    menus: this.selectedMenus
                }
                this.selectedMenus = []
                if (action == 'remove') {
                    await this.$store.dispatch('removeAuthMenus',params)
                    await this.$store.dispatch('listAuthMenu',this.$route.params.id)
                    return
                }
                await this.$store.dispatch('addAuthMenus',params)
                await this.$store.dispatch('listAuthMenu',this.$route.params.id)

            },
            sendSelectMenus: async function(action){
                let params = {
                    auth: this.$route.params.id,
                    menus: [...this.getCurrentMenuIds, ...this.selectedMenus]
                }
                this.selectedMenus = []
                if (action == 'remove') { 
                    params.menus = this.selectedAuthMenus
                    this.selectedAuthMenus = []
                    await this.$store.dispatch('removeAuthMenus',params)
                    await this.$store.dispatch('listAuthMenu',this.$route.params.id)
                    return
                }
                await this.$store.dispatch('addAuthMenus',params)
                await this.$store.dispatch('listAuthMenu',this.$route.params.id)

            }
        },
        components:{
            Treeselect, BreadCrumb
        },
      
        computed: {
            getCurrentMenuIds() {
                return [...new Set(this.authMenus
                .map(menu => menu.children
                .map(child => [menu.id, child.id]))
                .flat(2))]
            },
            loading(){
                return this.$store.getters.getLoading
            },
            message(){
                return this.$store.getters.getCustomerContactInfo
            },
            menus(){
                return this.$store.getters.getUserMenus
            },
            authMenus(){
                return this.$store.getters.getAuthMenus
            },
            unauthorizedMenus() {
                const unauthorizedMenus = []
                const authorizedIds = this.authMenus
                .map(menu => menu.children.map(child => child.id)).flat(2)

                this.menus.forEach(menu => {
                    const subUnauthorized = menu.children.filter(child => {
                        return authorizedIds.every(id => id != child.id)
                    })
                    if (!subUnauthorized.length) return
                    const unauthorizeds = {...menu, children: subUnauthorized}
                    unauthorizedMenus.push(unauthorizeds)
                })
                return unauthorizedMenus
            },
        },
        data: function(){
            return{
                selectedMenus: [],
                selectedAuthMenus: [],
                breadCrumb,
            }
        },
        props:{
            data: Array,
            changeData: Function,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function,
        }

    }
</script>
<style lang="css" scoped > 
    @import "./styles/casbin.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Users/AuthMenus.vue